import { IsObject, noop } from '../helpers';
export function IsPromiseLike(value) {
    return IsPromiseLikeBase(value)
        && (typeof value.catch === 'function')
        && (typeof value.finally === 'function');
}
export function IsPromiseLikeBase(value) {
    return IsObject(value)
        && (typeof value.then === 'function');
}
export const NEVER_PROMISE = new Promise(noop);
export const VOID_PROMISE = Promise.resolve();
export function PromiseCreateCallbackNoop() {
    return () => {
    };
}
export function PromiseCreateCallbackResolve(value) {
    return (resolve) => resolve(value);
}
export function PromiseCreateCallbackReject(reason) {
    return (resolve, reject) => reject(reason);
}
export function PromiseTry(callback) {
    return new Promise(resolve => resolve(callback()));
}
export function EnsuresPromise(promise) {
    return (promise instanceof Promise)
        ? promise
        : Promise.resolve(promise);
}
export function Finally(onFinally) {
    return (typeof onFinally === 'function')
        ? [
            (value) => {
                return PromiseTry(onFinally)
                    .then(() => value);
            },
            (reason) => {
                return PromiseTry(onFinally)
                    .then(() => {
                    throw reason;
                });
            }
        ] : [void 0, void 0];
}
export function AllSettled(promises) {
    return Promise.all(Array.from(promises, (promise) => {
        return promise
            .then((value) => ({ status: 'fulfilled', value: value }), (reason) => ({ status: 'rejected', reason: reason }));
    }));
}
export function SpreadCancellablePromiseTuple({ promise, controller }) {
    return [promise, controller.signal];
}
//# sourceMappingURL=helpers.js.map